import { render, staticRenderFns } from "./AvatarCropper.vue?vue&type=template&id=efd79ece&"
import script from "./AvatarCropper.vue?vue&type=script&lang=js&"
export * from "./AvatarCropper.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCropper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports